module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_8004.62ad2128.png";